<template>
  <div id="main-wrapper" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <AdminNavbar />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="ipt-title">{{ $t('Welcome!') }}</h2>
            <span class="ipn-subtitle">{{ $t('Welcome To Your Account') }}</span>
          </div>
        </div>
      </div>
    </div>

    <section class="bg-light">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="filter_search_opt">
              <router-link to="" @click="show = !show" class="btn btn-dark full-width mb-4">
                Dashboard Navigation<i class="fa-solid fa-bars ms-2"></i>
              </router-link>
            </div>
          </div>
        </div>

        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-md-6 col-lg-5">
                <div class="dashboard-wraper w-100">
                <h4>{{ $t('Change Your Password') }}</h4>
                <br>
                <div class="row align-items-center">
                <div class="col-6">
                  <p class="mb-0">{{ t('Contact us directly') }}: <strong>00963952705700</strong></p>
                </div>
                <div class="col-6 text-end">
                  <a
                    href="https://wa.me/+963952705700"
                    target="_blank"
                    rel="noopener"
                  >
                    <i class="fab fa-whatsapp"></i>{{ $t('whatsapp') }}
                  </a>
                </div>
              </div>
                </div>
            </div>
        </div>
      </div>
    </section>

    <FooterTop :bg="'theme-bg'" />
    <FooterDark />
    <ScrollToTop />
  </div>
</template>
<script setup>
import AdminNavbar from '@/components/navbar/admin-navbar.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import { useI18n } from "vue-i18n";

const { t } = useI18n();

</script>
